import React, { useState, useEffect, useRef } from 'react';
import '../../css/bootstrap.min.css';
import '../../css/feathericon.min.css';
import '../../css/font-awesome.min.css';
import '../../css/select2.min.css';
import '../../css/style.css';
import Calendar from 'react-calendar'; 
import 'react-calendar/dist/Calendar.css'; 
import '../../css/admin-sidebar.css';
import axios from 'axios';
import AdminSidebar from '../Adminsidebar/AdminSidebar';
import logo from "../../../assets/img/logo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faPlusCircle, faTrashAlt,faClock  } from '@fortawesome/free-solid-svg-icons';
import './AddDoctor.css'

const getFormattedDateKey = (date) => {
    if (!date) return '';
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
};

const formatTime12Hour = (time24) => {
    if (!time24) return 'N/A';
    const [hours, minutes] = time24.split(':');
    let hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12 || 12;
    return `${hour}:${minutes} ${ampm}`;
};

function DoctorList() {
    const [doctors, setDoctors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [showAddModal, setShowAddModal] = useState(false);

    // New Doctor State
    const [newDoctorName, setNewDoctorName] = useState('');
    const [newDoctorSpeciality, setNewDoctorSpeciality] = useState('');
    const [newDoctorAddress, setNewDoctorAddress] = useState('');
    const [newDoctorPrice, setNewDoctorPrice] = useState('');
    const [newDoctorImage, setNewDoctorImage] = useState(null);
    // --- MODIFIED: Initial state now includes isAvailable property ---
    const [newDoctorAvailability, setNewDoctorAvailability] = useState([{ startTime: '09:00', endTime: '17:00', isAvailable: true }]);

    const [message, setMessage] = useState('');

    // Edit Doctor State
    const [showEditModal, setShowEditModal] = useState(false);
    const [editDoctorId, setEditDoctorId] = useState(null);
    const [editDoctorOriginal, setEditDoctorOriginal] = useState(null);
    const [editDoctorName, setEditDoctorName] = useState('');
    const [editDoctorSpeciality, setEditDoctorSpeciality] = useState('');
    const [editDoctorAddress, setEditDoctorAddress] = useState('');
    const [editDoctorPrice, setEditDoctorPrice] = useState('');
    const [editDoctorImage, setEditDoctorImage] = useState(null);
    
    // --- MODIFIED: Renamed for clarity ---
    const [editDoctorAvailableDates, setEditDoctorAvailableDates] = useState([]); 
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteDoctorId, setDeleteDoctorId] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [doctorsPerPage, setDoctorsPerPage] = useState(5);

    // --- State for Edit Modal ---
    const [editDefaultAvailability, setEditDefaultAvailability] = useState([]);
    const [editDateOverrides, setEditDateOverrides] = useState({});
    const [selectedDate, setSelectedDate] = useState(new Date());

    
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.hitkarihospital.com:5005';
    const DEFAULT_IMAGE = logo;
    const dataTableRef = useRef(null);

    // --- Filtering and Pagination Logic (Unchanged) ---
    const filteredDoctors = doctors.filter(doctor => {
        const searchStr = searchTerm.toLowerCase();
        return (
            (doctor.name && doctor.name.toLowerCase().includes(searchStr)) ||
            (doctor.speciality && doctor.speciality.toLowerCase().includes(searchStr)) ||
            (doctor.address && doctor.address.toLowerCase().includes(searchStr))
        );
    });
    const indexOfLastDoctor = currentPage * doctorsPerPage;
    const indexOfFirstDoctor = indexOfLastDoctor - doctorsPerPage;
    const currentDoctors = filteredDoctors.slice(indexOfFirstDoctor, indexOfLastDoctor);
    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(filteredDoctors.length / doctorsPerPage); i++) {
        pageNumbers.push(i);
    }

    useEffect(() => {
        fetchDoctors();
    }, []);

    const fetchDoctors = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${API_BASE_URL}/api/doctor`);
            setDoctors(response.data || []);
        } catch (err) {
            console.error("Error fetching doctors:", err);
            setError("Failed to fetch doctor data.");
            setDoctors([]);
        } finally {
            setLoading(false);
        }
    };
    
    // --- Availability Helper Functions (Unchanged) ---
    const handleAddAvailabilitySlot = (type) => {
        if (type === 'new') {
            setNewDoctorAvailability([...newDoctorAvailability, { startTime: '09:00', endTime: '17:00', isAvailable: true }]);
        }
    };
    const handleRemoveAvailabilitySlot = (index, type) => {
        if (type === 'new') {
            const updatedSlots = newDoctorAvailability.filter((_, i) => i !== index);
            setNewDoctorAvailability(updatedSlots);
        }
    };
    const handleAvailabilityChange = (index, field, value, type) => {
        if (type === 'new') {
            const updatedSlots = [...newDoctorAvailability];
            updatedSlots[index][field] = value;
            setNewDoctorAvailability(updatedSlots);
        }
    };
    
    // --- NEW: Handlers specifically for the Default Schedule in the Edit Modal ---
    const handleAddDefaultSlot = () => {
        setEditDefaultAvailability(prev => [...prev, { startTime: '09:00', endTime: '17:00', isAvailable: true }]);
    };
    const handleRemoveDefaultSlot = (index) => {
        setEditDefaultAvailability(prev => prev.filter((_, i) => i !== index));
    };
    const handleDefaultSlotChange = (index, field, value) => {
        setEditDefaultAvailability(prev => {
            const updatedSlots = [...prev];
            updatedSlots[index] = { ...updatedSlots[index], [field]: value };
            return updatedSlots;
        });
    };

    // --- Handlers for Date-Specific Overrides in Edit Modal (Unchanged) ---
    const handleAddSlotForSelectedDate = () => {
        const dateKey = getFormattedDateKey(selectedDate);
        const currentSlots = editDateOverrides[dateKey] ? [...editDateOverrides[dateKey]] : [...editDefaultAvailability];
        const newSlots = [...currentSlots, { startTime: '09:00', endTime: '17:00', isAvailable: true }];
        setEditDateOverrides(prev => ({ ...prev, [dateKey]: newSlots }));
    };
    const handleRemoveSlotForSelectedDate = (index) => {
        const dateKey = getFormattedDateKey(selectedDate);
        const currentSlots = editDateOverrides[dateKey] ? [...editDateOverrides[dateKey]] : [...editDefaultAvailability];
        const updatedSlots = currentSlots.filter((_, i) => i !== index);
        setEditDateOverrides(prev => ({ ...prev, [dateKey]: updatedSlots }));
    };
    const handleSlotChangeForSelectedDate = (index, field, value) => {
        const dateKey = getFormattedDateKey(selectedDate);
        const currentSlots = editDateOverrides[dateKey] ? [...editDateOverrides[dateKey]] : [...editDefaultAvailability];
        const updatedSlots = [...currentSlots];
        updatedSlots[index] = { ...updatedSlots[index], [field]: value };
        setEditDateOverrides(prev => ({ ...prev, [dateKey]: updatedSlots }));
    };
    const handleResetDateToDefault = () => {
        const dateKey = getFormattedDateKey(selectedDate);
        const newOverrides = { ...editDateOverrides };
        delete newOverrides[dateKey];
        setEditDateOverrides(newOverrides);
    };

    // --- Modal Open/Close Handlers ---
    const handleEditDoctor = (doctor) => {
        setEditDoctorId(doctor.doctorId);
        setEditDoctorOriginal(doctor);
        setEditDoctorName(doctor.name);
        setEditDoctorSpeciality(doctor.speciality);
        setEditDoctorAddress(doctor.address);
        setEditDoctorPrice(doctor.price);
        setEditDoctorImage(null);
        setEditDefaultAvailability(doctor.defaultAvailability || [{ startTime: '09:00', endTime: '17:00', isAvailable: true }]);
        setEditDateOverrides(doctor.dateOverrides || {}); 
        setSelectedDate(new Date());
        setShowEditModal(true);
        setMessage('');
    };
    const handleCloseModal = () => {
        setShowAddModal(false);
        setShowEditModal(false);
        setShowDeleteModal(false);
        setMessage('');
    };

    // --- Form Submit Handlers ---
    const handleAddDoctorSubmit = async (e) => {
        e.preventDefault();
        setMessage('');

        if (!newDoctorName || !newDoctorSpeciality || !newDoctorAddress || !newDoctorPrice || !newDoctorImage) {
            setMessage('Please fill all basic fields and select an image.');
            return;
        }

        const formData = new FormData();
        formData.append('name', newDoctorName);
        formData.append('speciality', newDoctorSpeciality);
        formData.append('address', newDoctorAddress);
        formData.append('price', newDoctorPrice);
        formData.append('image', newDoctorImage);
        
        // --- MODIFIED: Changed 'availability' to 'defaultAvailability' to match the schema ---
        formData.append('defaultAvailability', JSON.stringify(newDoctorAvailability));

        try {
            const response = await axios.post(`${API_BASE_URL}/api/doctor`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            setMessage(response.data.message);
            fetchDoctors();
            handleCloseModal();
        } catch (err) {
            setMessage('Error adding doctor: ' + (err.response?.data?.error || err.message));
        }
    };

    const handleEditDoctorSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('name', editDoctorName);
        formData.append('speciality', editDoctorSpeciality);
        formData.append('address', editDoctorAddress);
        formData.append('price', editDoctorPrice);
        if (editDoctorImage) formData.append('image', editDoctorImage);

        // --- These fields are now correctly managed by the new modal UI ---
        formData.append('defaultAvailability', JSON.stringify(editDefaultAvailability));
        formData.append('dateOverrides', JSON.stringify(editDateOverrides));

        try {
            await axios.put(`${API_BASE_URL}/api/doctor/${editDoctorId}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            fetchDoctors();
            handleCloseModal();
        } catch (err) {
            setMessage('Error updating doctor: ' + (err.response?.data?.error || err.message));
        }
    };
    
    // Logic to determine which slots to show in the date override section
    const slotsForSelectedDate = editDateOverrides[getFormattedDateKey(selectedDate)] ?? editDefaultAvailability;
    
    const tileClassName = ({ date, view }) => {
        if (view === 'month') {
            // Highlight dates that have an override
            const dateKey = getFormattedDateKey(date);
            if (editDateOverrides && editDateOverrides[dateKey]) {
                return 'date-overridden'; // Custom CSS class for overridden dates
            }
        }
        return null;
    };


    // --- Other handlers (delete, search, etc. - Unchanged) ---
    const handleDeleteDoctor = (doctorId) => {
        setDeleteDoctorId(doctorId);
        setShowDeleteModal(true);
    };
    const confirmDelete = async () => {
        try {
            await axios.delete(`${API_BASE_URL}/api/doctor/${deleteDoctorId}`);
            fetchDoctors();
            handleCloseModal();
        } catch (err) {
            setMessage('Error deleting doctor: ' + (err.response?.data?.error || err.message));
        }
    };
    const handleSearch = (e) => { setSearchTerm(e.target.value); setCurrentPage(1); };
    const paginate = pageNumber => setCurrentPage(pageNumber);
  const handleDoctorPerPageChange = (e) => {
        setDoctorsPerPage(parseInt(e.target.value, 10));
        setCurrentPage(1);
    };

    const handleNewDoctorImageChange = (e) => {
        setNewDoctorImage(e.target.files[0]);
    };

    const handleEditDoctorImageChange = (e) => {
        setEditDoctorImage(e.target.files[0]);
    };
    // Reusable component for availability forms
    const AvailabilityFormSection = ({ availability, onAdd, onRemove, onChange, type }) => (
        <div className="form-group">
            {availability.map((slot, index) => (
                <div key={index} className="row align-items-center mb-2 availability-slot">
                    <div className="col-md-3">
                        <div className="availability-checkbox-wrapper">
                            <input
                                type="checkbox"
                                id={`available-${type}-${index}`}
                                className="availability-checkbox"
                                checked={slot.isAvailable}
                                onChange={(e) => onChange(index, 'isAvailable', e.target.checked, type)}
                            />
                            <label htmlFor={`available-${type}-${index}`}>Available</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <label className="small mb-1 d-block text-muted">Start Time</label>
                        <input
                            type="time"
                            className="form-control form-control-sm"
                            value={slot.startTime}
                            onChange={(e) => onChange(index, 'startTime', e.target.value, type)}
                            required
                        />
                    </div>
                    <div className="col-md-4">
                        <label className="small mb-1 d-block text-muted">End Time</label>
                        <input
                            type="time"
                            className="form-control form-control-sm"
                            value={slot.endTime}
                            onChange={(e) => onChange(index, 'endTime', e.target.value, type)}
                            required
                        />
                    </div>
                    <div className="col-md-1 text-right align-self-end">
                        <button type="button" className="btn btn-sm btn-danger" onClick={() => onRemove(index, type)}>
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </button>
                    </div>
                </div>
            ))}
            <button type="button" className="btn btn-sm btn-outline-primary mt-2" onClick={() => onAdd(type)}>
                <FontAwesomeIcon icon={faPlusCircle} /> Add Slot
            </button>
        </div>
    );

    if (loading) return (
        <div className="main-wrapper">
            <AdminSidebar />
            <div className="page-wrapper"><div className="content container-fluid"><p>Loading Doctors...</p></div></div>
        </div>
    );
    if (error && doctors.length === 0) return (
        <div className="main-wrapper">
            <AdminSidebar />
            <div className="page-wrapper"><div className="content container-fluid"><p>Error: {error}</p></div></div>
        </div>
    );
const formatTime12Hour = (time24) => {
  if (!time24) return 'N/A'; // Handle case where time is not available

  // Split the time string into hours and minutes
  const [hours, minutes] = time24.split(':');

  // Convert hours from string to number
  let hour = parseInt(hours, 10);

  // Determine AM or PM
  const ampm = hour >= 12 ? 'PM' : 'AM';

  // Convert hour to 12-hour format
  hour = hour % 12;
  // If hour is 0 (e.g., 12 AM), it should be 12
  hour = hour ? hour : 12;

  // Return the formatted time string
  return `${hour}:${minutes} ${ampm}`;
};

    return (
        <div className="main-wrapper">
            <AdminSidebar />
            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="page-header">
                        <div className="row">
                            <div className="col-sm-7 col-auto">
                                <h3 className="page-title">List of Doctors</h3>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/dash">Dashboard</a></li>
                                    <li className="breadcrumb-item"><a href="#!">Users</a></li>
                                    <li className="breadcrumb-item active">Doctor</li>
                                </ul>
                            </div>
                            <div className="col-sm-5 col">
                             <a href="/adddoctor">  <button  className="btn btn-primary float-right mt-2">Add Doctor</button></a> 
                            </div>
                        </div>
                    </div>

                    {message && <div className={`alert ${message.toLowerCase().includes('error') ? 'alert-danger' : 'alert-info'}`}>{message}</div>}

                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search doctors by name, speciality, or address..."
                                            value={searchTerm}
                                            onChange={handleSearch}
                                        />
                                    </div>
                                    <div className="row mb-3 align-items-center">
                                        <div className="col-md-3">
                                            <label htmlFor="doctorsPerPageSelect">Doctors per page:</label>
                                            <select
                                                id="doctorsPerPageSelect"
                                                className="form-control"
                                                value={doctorsPerPage}
                                                onChange={handleDoctorPerPageChange}
                                            >
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="15">15</option>
                                                <option value="50">50</option>
                                            </select>
                                        </div>
                                        <div className="col-md-9 d-flex justify-content-end">
                                            {pageNumbers.length > 1 && (
                                                <nav aria-label="Doctor pagination">
                                                    <ul className="pagination mb-0">
                                                        {pageNumbers.map(number => (
                                                            <li key={number} className={`page-item ${currentPage === number ? 'active' : ''}`}>
                                                                <button onClick={() => paginate(number)} className="page-link">
                                                                    {number}
                                                                </button>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </nav>
                                            )}
                                        </div>
                                    </div>

                                    <div className="table-responsive">
                                        <table key={currentDoctors.length} className="datatable table table-hover table-center mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Doctor ID</th>
                                                    <th>Doctor Name</th>
                                                    <th>Speciality</th>
                                                    <th>Address</th>
                                                    <th>Fees</th>
                                                    {/* <th>Availability</th> */}
                                                    <th className="text-right">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentDoctors.length > 0 ? currentDoctors.map((doctor) => {
                                                    const doctorImage = doctor.image ? `${API_BASE_URL}/doctor/${doctor.image}` : DEFAULT_IMAGE;
                                                    return (
                                                        <tr key={doctor.doctorId}>
                                                            <td>{doctor.doctorId}</td>
                                                            <td>
                                                                <h2 className="table-avatar">
                                                                    <a href={`#!`} className="avatar avatar-sm mr-2">
                                                                        <img
                                                                            className="avatar-img rounded-circle"
                                                                            src={doctorImage}
                                                                            alt={doctor.name || "Doctor"}
                                                                            onError={(e) => { e.target.onerror = null; e.target.src = DEFAULT_IMAGE; }}
                                                                            style={{ width: '40px', height: '40px', objectFit: 'cover' }}
                                                                        />
                                                                    </a>
                                                                    <a href={`#!`}>{doctor.name}</a>
                                                                </h2>
                                                            </td>
                                                            <td>{doctor.speciality || "Not specified"}</td>
                                                            <td>{doctor.address || "No Address"}</td>
                                                            <td>₹{doctor.price != null ? Number(doctor.price).toFixed(2) : "0.00"}</td>

                                                            {/* <td>
  {doctor.availability && doctor.availability.length > 0 ? (
    doctor.availability.map((slot, idx) => (
      <span key={idx} className="hitkari-doc-timing" style={{ display: "inline-block", marginRight: "10px", marginBottom: "5px" }}>
        <FontAwesomeIcon icon={faClock} style={{ marginRight: "5px", color: "#007bff" }} />
        {formatTime12Hour(slot.startTime)} - {formatTime12Hour(slot.endTime)}
      </span>
    ))
  ) : (
    'Not Set'
  )}
</td> */}

                                                            <td className="text-right">
                                                                <div className="actions">
                                                                    <button
                                                                        onClick={() => handleEditDoctor(doctor)}
                                                                        className="btn btn-sm bg-success-light mr-1"
                                                                    >
                                                                        <i className="fe fe-pencil"></i> Edit
                                                                    </button>
                                                                    <button
                                                                        onClick={() => handleDeleteDoctor(doctor.doctorId)}
                                                                        className="btn btn-sm bg-danger-light"
                                                                    >
                                                                        <i className="fe fe-trash"></i> Delete
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                }) : (
                                                    <tr>
                                                        <td colSpan="5" className="text-center">No doctors found.</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add Modal */}
            {showAddModal && (
                <>
                    <div className="modal-backdrop fade show"></div>
                    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Add Doctor</h5>
                                    <button type="button" className="close" aria-label="Close" onClick={handleCloseModal}>
                                        <FontAwesomeIcon icon={faTimes} />
                                    </button>
                                </div>
                             <div className="addDoctorModal-body">
    {message && (
        <div className={`addDoctorModal-message ${message.toLowerCase().includes('error') ? 'is-error' : 'is-info'}`}>
            {message}
        </div>
    )}
    <form onSubmit={handleAddDoctorSubmit} className="addDoctorModal-form">
        <div className="addDoctorModal-grid">

            {/* ----- Doctor Name ----- */}
            <div className="addDoctorModal-form-group">
                <label htmlFor="docName" className="addDoctorModal-label">Doctor Name</label>
                <input 
                    id="docName" 
                    type="text" 
                    className="addDoctorModal-input" 
                    value={newDoctorName} 
                    onChange={(e) => setNewDoctorName(e.target.value)} 
                    required 
                />
            </div>

            {/* ----- Speciality ----- */}
            <div className="addDoctorModal-form-group">
                <label htmlFor="docSpeciality" className="addDoctorModal-label">Speciality</label>
                <input 
                    id="docSpeciality" 
                    type="text" 
                    className="addDoctorModal-input" 
                    value={newDoctorSpeciality} 
                    onChange={(e) => setNewDoctorSpeciality(e.target.value)} 
                    required 
                />
            </div>

            {/* ----- Address ----- */}
            <div className="addDoctorModal-form-group">
                <label htmlFor="docAddress" className="addDoctorModal-label">Address</label>
                <input 
                    id="docAddress" 
                    type="text" 
                    className="addDoctorModal-input" 
                    value={newDoctorAddress} 
                    onChange={(e) => setNewDoctorAddress(e.target.value)} 
                    required 
                />
            </div>

            {/* ----- Fees ----- */}
            <div className="addDoctorModal-form-group">
                <label htmlFor="docFees" className="addDoctorModal-label">Fees (₹)</label>
                <input 
                    id="docFees" 
                    type="number" 
                    step="0.01" 
                    className="addDoctorModal-input" 
                    value={newDoctorPrice} 
                    onChange={(e) => setNewDoctorPrice(e.target.value)} 
                    required 
                />
            </div>

            {/* ----- Image Upload (Full Width) ----- */}
            <div className="addDoctorModal-form-group addDoctorModal-full-width">
                <label htmlFor="docImage" className="addDoctorModal-label">Doctor's Image</label>
                <input 
                    id="docImage" 
                    type="file" 
                    className="addDoctorModal-input-file" 
                    onChange={handleNewDoctorImageChange} 
                    accept="image/*" 
                    required 
                />
            </div>

            {/* ----- Availability Section (Full Width) ----- */}
            <div className="addDoctorModal-form-group addDoctorModal-full-width">
                 <label className="addDoctorModal-label">Availability Slots</label>
                <AvailabilityFormSection
                    availability={newDoctorAvailability}
                    onAdd={() => handleAddAvailabilitySlot('new')}
                    onRemove={(index) => handleRemoveAvailabilitySlot(index, 'new')}
                    onChange={handleAvailabilityChange}
                    type="new"
                />
            </div>
        </div>

        {/* ----- Submit Button ----- */}
        <button type="submit" className="addDoctorModal-submit-btn">Add Doctor</button>
    </form>
</div>
                            </div>
                        </div>
                    </div>
                </>
            )}

        {/* Edit Doctor Schedule Modal */}
{showEditModal && (
    <>
        <div className="hitkari-doc-modal-backdrop hitkari-doc-fade hitkari-doc-show"></div>
        <div 
            className="hitkari-doc-modal hitkari-doc-fade hitkari-doc-show" 
            id="doctorEditModal" 
            style={{ display: 'block' }} 
            tabIndex="-1" 
            role="dialog"
        >
            <div className="hitkari-doc-modal-dialog hitkari-doc-modal-dialog-centered" role="document">
                <div className="hitkari-doc-modal-content">
                    
                    {/* Header */}
                    <div className="hitkari-doc-modal-header">
                        <h5 className="hitkari-doc-modal-title">Edit Doctor Schedule</h5>
                        <button 
                            type="button" 
                            className="hitkari-doc-close" 
                            aria-label="Close" 
                            onClick={handleCloseModal}
                        >
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    </div>
                    
                    {/* Body */}
                    <div className="hitkari-doc-modal-body">
                        {message && (
                            <div 
                                className={`hitkari-doc-alert ${
                                    message.toLowerCase().includes('error') 
                                    ? 'hitkari-doc-alert-danger' 
                                    : 'hitkari-doc-alert-info'
                                }`}
                            >
                                {message}
                            </div>
                        )}

                        <form onSubmit={handleEditDoctorSubmit}>
                            {/* Basic Info */}
                            <div className="row form-row">
                                <div className="col-12 col-md-6">
                                    <div className="hitkari-doc-form-group">
                                        <label>Name</label>
                                        <input
                                            type="text"
                                            className="hitkari-doc-form-control"
                                            value={editDoctorName}
                                            onChange={(e) => setEditDoctorName(e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="hitkari-doc-form-group">
                                        <label>Speciality</label>
                                        <input
                                            type="text"
                                            className="hitkari-doc-form-control"
                                            value={editDoctorSpeciality}
                                            onChange={(e) => setEditDoctorSpeciality(e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
  <div className="edit-form-group">
                                <label>Address</label>
                                <input type="text" className="edit-form-control" value={editDoctorAddress} onChange={(e) => setEditDoctorAddress(e.target.value)} required />
                            </div>
                            <div className="edit-form-group">
                                <label>Fees (₹)</label>
                                <input type="number" step="0.01" className="edit-form-control" value={editDoctorPrice} onChange={(e) => setEditDoctorPrice(e.target.value)} required />
                            </div>
                            <div className="edit-form-group">
                                <label>Current Image:</label>
                                <img
                                    src={editDoctorOriginal.image ? `${API_BASE_URL}/doctor/${editDoctorOriginal.image}` : DEFAULT_IMAGE}
                                    alt="Current Doctor"
                                    className="edit-current-image"
                                    onError={(e) => { e.target.onerror = null; e.target.src = DEFAULT_IMAGE; }}
                                />
                                <label className="edit-new-image-label">New Image</label>
                                <input type="file" className="edit-form-control-file" onChange={handleEditDoctorImageChange} accept="image/*" />
                            </div>
                            <hr />
   <h5 className="mb-3 text-primary">Default Weekly Schedule</h5>
                                        <p className="text-muted small">
                                            This is the doctor's standard schedule that will apply **every day** unless you set a specific override below.
                                        </p>
                                        <AvailabilityFormSection
                                            availability={editDefaultAvailability}
                                            onAdd={handleAddDefaultSlot}
                                            onRemove={handleRemoveDefaultSlot}
                                            onChange={handleDefaultSlotChange}
                                            type="default-edit"
                                        />
                                        {/* --- END OF MISSING SECTION --- */}
                                        
                                        <hr />
                            {/* Availability Management */}
                             <h5 className="mb-3 text-primary">Manage Date-Specific Overrides</h5>
                                        <div className="row">
                                            <div className="col-lg-5">
                                                <h6>Select a Date</h6>
                                                <p className="text-muted small">Dates with custom schedules are highlighted.</p>
                                                <div className="hitkari-doc-calendar-wrapper">
                                                    <Calendar
                                                        onChange={setSelectedDate}
                                                        value={selectedDate}
                                                        tileClassName={tileClassName}
                                                        minDate={new Date()}
                                                    />
                                                </div>
                                            </div>

                                <div className="col-lg-7">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <h6>Schedule for: <strong>{selectedDate.toLocaleDateString()}</strong></h6>
                                                    {editDateOverrides[getFormattedDateKey(selectedDate)] && (
                                                        <button
                                                            type="button"
                                                            className="hitkari-doc-btn hitkari-doc-btn-sm hitkari-doc-btn-outline-secondary"
                                                            onClick={handleResetDateToDefault}
                                                        >
                                                            Reset to Default
                                                        </button>
                                                    )}
                                                </div>
                                                <AvailabilityFormSection
                                                    availability={slotsForSelectedDate}
                                                    onAdd={handleAddSlotForSelectedDate}
                                                    onRemove={handleRemoveSlotForSelectedDate}
                                                    onChange={handleSlotChangeForSelectedDate}
                                                />
                                            </div>
                                        </div>

                            <div className="submit-section mt-4">
                                <button 
                                    type="submit" 
                                    className="hitkari-doc-btn hitkari-doc-btn-primary hitkari-doc-btn-block"
                                >
                                    Save All Changes
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </>
)}



            {/* Delete Modal */}
            {showDeleteModal && (
                <>
                    <div className="modal-backdrop fade show"></div>
                    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Confirm Delete</h5>
                                    <button type="button" className="close" aria-label="Close" onClick={handleCloseModal}>
                                        <FontAwesomeIcon icon={faTimes} />
                                    </button>
                                </div>
                                <div className="modal-body text-center">
                                    <i className="fe fe-trash-2" style={{ fontSize: '3rem', color: '#dc3545', marginBottom: '1rem' }}></i>
                                    <h4>Delete Doctor Profile?</h4>
                                    <p className="mb-4">Are you sure you want to delete this doctor's profile? This action cannot be undone.</p>
                                    <div className="d-flex justify-content-center">
                                        <button type="button" className="btn btn-danger mr-2" onClick={confirmDelete}>Delete</button>
                                        <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default DoctorList;